import axios from "axios";
import { successHandling } from "../helpers/successHandling";

export const getAppRunningListApi = async device_id => {
  let res = await axios({
    url: `/api/v2/device/running-application-datatable`,
    method: "GET",
    params: {
      device_id
    }
  });
  return res.data;
};
export const getDetectStatusApi = async device_id => {
  let res = await axios({
    url: `/api/v2/device/detect-application-status`,
    method: "GET",
    params: {
      device_id
    }
  });
  return res.data;
};
export const detectAppRunningApi = async device_ids => {
  let res = await axios({
    url: `/api/v2/command/detect-usb-port-send`,
    method: "POST",
    data: {
      device_ids,
      execute_type: "detect_running_applications"
    }
  });
  return res.data;
};

export const getNetworkSpeedListApi = async device_id => {

  let res = await axios({
    url: `/api/v2/device/network-speed-test-datatable`,
    method: "GET",
    params: {
      device_id,
    }
  });
  return res.data;
};

export const networkSpeedTestApi = async device_ids => {
  let res = await axios({
    url: `/api/v2/command/network-speed-test-send`,
    method: "POST",
    data: {
      device_ids,
      execute_type: "detect_network_speedtest"
    }
  });
  return res.data;
};

export const executeAppRunningApi = async (
  ids,
  name,
  running_application_id,
  path,
  script,
  t,
  successfulText
) => {
  const device_ids = [ids];

  let res = await axios({
    url: `/api/v2/command/execute-running-app-send`,
    method: "POST",
    data: {
      device_ids,
      execute_type: "execute_application",
      running_application_id,
      name,
      path,
      script
    }
  });
  successHandling(t, successfulText);
  return res.data;
};

export const stopAppRunningApi = async (
  ids,
  running_application_id,
  stop_app,
  t,
  successfulText
) => {
  const device_ids = [ids];

  let res = await axios({
    url: `/api/v2/command/stop-running-app-send`,
    method: "POST",
    data: {
      device_ids,
      stop_app,
      running_application_id,
      execute_type: "stop_running_application"
    }
  });
  successHandling(t, successfulText);
  return res.data;
};
